/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import _drop from 'lodash/drop';
import _take from 'lodash/take';
import type User from 'volta/models/user';
import type UserProfile from 'volta/models/user-profile';
import { userName } from 'volta/utils/text-utils';

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

import type { TSize } from 'volta/utils/style-utils';
import type SessionUserService from 'volta/services/session-user';

const SHOW_USERS_LIMIT = 2;

interface BvAvatarGroupSignature {
  Args: {
    size?: TSize;
    users: (UserProfile | User)[];
  };
  Element: HTMLDivElement;
}

export default class BvAvatarGroupComponent extends Component<BvAvatarGroupSignature> {
  @service sessionUser!: SessionUserService;

  get users() {
    return Array.isArray(this.args.users)
      ? this.args.users.slice()
      : [];
  }

  get showedUsers() {
    const { users } = this;
    return _take(
      users,
      users.length === SHOW_USERS_LIMIT + 1 ? SHOW_USERS_LIMIT + 1 : SHOW_USERS_LIMIT
    );
  }

  get hiddenUserNames() {
    const { users } = this;
    return _drop<User | UserProfile>(users, 2)
      .map((user) => userName(user.firstName, user.lastName, user.login) ?? '')
      .join(', ');
  }

  get showCount() {
    return this.users.length > SHOW_USERS_LIMIT + 1;
  }

  get count() {
    return this.users.length - SHOW_USERS_LIMIT;
  }

  username = (user: User | UserProfile) =>
    userName(user.firstName, user.lastName, user.login) ?? '';
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvAvatarGroup: typeof BvAvatarGroupComponent;
    'bv-avatar-group': typeof BvAvatarGroupComponent;
  }
}
